import { assertInInjectionContext, inject, Injector, runInInjectionContext } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, Observable, of, pipe, switchMap, tap, UnaryFunction } from 'rxjs';
import { LoggerWithConfigurationService } from '../../service/internal/logger-with-configuration.service';
import { UserService } from '../../service/user/user.service';
import { createPrefixMessage } from '../prefix-message.function';

export function andUserIsNot<T>(
  target: string,
  { injector }: { injector?: Injector } = {},
): UnaryFunction<Observable<T>, Observable<T>> {
  if (!injector) {
    assertInInjectionContext(andUserIsNot);
    injector = inject(Injector);
  }
  assertInInjectionContext(andUserIsNot);
  return runInInjectionContext(injector, () => {
    const prefixMessage = createPrefixMessage('andUserIs');
    const loggerService = inject(LoggerWithConfigurationService);
    const isNot$ = toObservable(inject(UserService).user.isNot(target));

    return pipe(
      switchMap((value: T) =>
        of(value).pipe(
          tap(() => {
            loggerService.logDebug(prefixMessage(`Checking user roles.`));
          }),
          switchMap(() => isNot$),
          filter((result) => result),
          map(() => value),
        ),
      ),
    );
  });
}
